<template>
  <div class="clm-form-btns__cnt">
    <button @click="$emit('action')"
            type="button"
            class="clm-frm-btn"
            :class="classObj"
            :disabled="isDisabled"
            tabindex="1"
    >
      <span class="clm-frm-btn__text"><slot v-if="!isLoading"></slot><span v-else> </span></span>
      <span class="clm-frm-btn__loader"></span>
    </button>
  </div>
</template>

<script>
export default {
  name: "a-submit-btn",
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },
    isOutline: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classObj() {
      return {
        'clm-frm-btn--disable' : this.isDisabled,
        'clm-frm-btn--color' : !this.isDisabled && !this.isOutline,
        'is-loading' : this.isLoading
      }
    }
  }
}
</script>